require('angular-sanitize');
require('angular-aria');
angular.module('ui-ng-popup', ['ngSanitize', 'ngAria', 'ui-ng-ax']);
require('./core.ts');
// import modules
export * from './services/services_module';



// WEBPACK FOOTER //
// ./app/vendor/ui-ng-popup/src/main.ts